import React, { useCallback, useState } from "react"
import { Banner, Modal } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import { useFormContext } from "./FormContext"

const useConfirmCollectionChange = (fieldId, hasData) => {
  const { formData, setFormData } = useFormContext()
  const { t } = useTranslation()
  const [pendingValue, setPendingValue] = useState(null)

  const onChange = useCallback(
    (value) => {
      const next = Array.isArray(value) ? value[0] : value
      const current = formData?.[fieldId]
      if (hasData && current != null && next !== current) {
        setPendingValue(next)
      } else {
        setFormData({ ...formData, [fieldId]: next })
      }
    },
    [formData, setFormData, fieldId, hasData]
  )

  const confirm = useCallback(() => {
    if (pendingValue != null) {
      setFormData({ ...formData, [fieldId]: pendingValue })
    }
    setPendingValue(null)
  }, [pendingValue, formData, setFormData, fieldId])

  const cancel = useCallback(() => setPendingValue(null), [])

  const confirmationModal = (
    <Modal
      small
      open={pendingValue !== null}
      onClose={cancel}
      title={t("collect:inventory_choice.confirm_change.title")}
      primaryAction={{
        content: t("collect:inventory_choice.confirm_change.confirm"),
        destructive: true,
        onAction: confirm,
      }}
      secondaryActions={[
        {
          content: t("collect:inventory_choice.confirm_change.cancel"),
          onAction: cancel,
        },
      ]}
    >
      <Modal.Section>
        <Banner
          status="critical"
          title={t("collect:inventory_choice.confirm_change.title")}
        >
          {t("collect:inventory_choice.confirm_change.description")}
        </Banner>
      </Modal.Section>
    </Modal>
  )

  return { onChange, confirmationModal }
}

export default useConfirmCollectionChange
